// Application entry point

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthStatus } from './types/auth';

// Initialize demo data
async function initializeDemoData() {
  // Clear and reinitialize demo data
  localStorage.removeItem('biurostock_companies');
  localStorage.removeItem('biurostock_users');
  localStorage.removeItem('biurostock_auth_session');
      // Create demo company
      const demoCompany = {
        id: 'demo_company_1',
        name: 'Demo Firma Sp. z o.o.',
        nip: '1234567890',
        address: 'ul. Przykładowa 123, 00-001 Warszawa',
        industry: 'Usługi IT',
        plan: 'pro',
        settings: {
          monthlyBudget: 10000,
          budgetAlert80: true,
          budgetAlert90: true,
          budgetAlert100: true,
          emailNotifications: true,
          smsNotifications: false,
          pushNotifications: true,
          autoOrderEnabled: true,
          currency: 'PLN'
        },
        createdAt: new Date(),
        updatedAt: new Date()
      };

      // Create demo users
      const demoUsers = [
        {
          id: 'demo_user_admin',
          companyId: 'demo_company_1',
          email: 'admin@demo.pl',
          firstName: 'Jan',
          lastName: 'Kowalski',
          role: 'admin',
          emailVerified: true,
          status: AuthStatus.ACTIVE,
          preferences: {
            theme: 'light',
            language: 'pl',
            defaultView: 'dashboard',
            notificationSettings: {
              email: true,
              push: true,
              sms: false,
              lowStockAlerts: true,
              budgetAlerts: true
            }
          },
          permissions: {
            canOrder: true,
            canEditStock: true,
            canViewReports: true,
            canManageUsers: true,
            canChangeSettings: true,
            canApproveOrders: true
          },
          createdAt: new Date(),
          lastLoginAt: null
        },
        {
          id: 'demo_user_manager',
          companyId: 'demo_company_1',
          email: 'manager@demo.pl',
          firstName: 'Anna',
          lastName: 'Nowak',
          role: 'ordering_manager',
          emailVerified: true,
          status: AuthStatus.ACTIVE,
          preferences: {
            theme: 'light',
            language: 'pl',
            defaultView: 'products',
            notificationSettings: {
              email: true,
              push: true,
              sms: false,
              lowStockAlerts: true,
              budgetAlerts: true
            }
          },
          permissions: {
            canOrder: true,
            canEditStock: true,
            canViewReports: true,
            canManageUsers: false,
            canChangeSettings: false,
            canApproveOrders: true
          },
          createdAt: new Date(),
          lastLoginAt: null
        }
      ];

      // Save demo data
      localStorage.setItem('biurostock_companies', JSON.stringify([demoCompany]));
      localStorage.setItem('biurostock_users', JSON.stringify(demoUsers));
}

// Initialize app
async function startApp() {
  await initializeDemoData();

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

startApp();